import { render } from "./SelectionCameraPopup.vue?vue&type=template&id=2cd1508e"
import script from "./SelectionCameraPopup.vue?vue&type=script&lang=ts"
export * from "./SelectionCameraPopup.vue?vue&type=script&lang=ts"

import "./SelectionCameraPopup.vue?vue&type=style&index=0&id=2cd1508e&lang=scss"
script.render = render

export default script